import AppHeader from "@/components/AppHeader";
let utils = require("../../utils");

export default {
  name: "master-site",
  components: {
    AppHeader
  },
  async created() {
    await this.getCompany();
    await this.getSites(false);
    utils.scrollBottomSearchEvent(
      this.getSites,
      true,
      "button.next-page-search-btn"
    );
  },
  data() {
    return {
      companies: "",
      sites: [],
      siteLists: [],
      selectedCompany: localStorage.company_id,
      keyword: null,
      getCompaniesEnd: false,
      getSitesEnd: false,
      file: null,
      uploadEnd: false,
      savingFlag: false,
      errorInfo: "",
      currentPage: 0,
      nextExist: false
    };
  },
  /** 画面遷移時 */
  beforeRouteLeave(to, from, next) {
    utils.scrollBottomSearchEventRemove(); // 最下部スクロール検索イベント削除
    next();
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async getSites(addSearch) {
      let data = {
        company_id: this.selectedCompany,
        search_word: this.keyword
      };
      if (addSearch) {
        this.currentPage += 1;
        data["current_page"] = this.currentPage;
        data["add_search"] = true;
      } else {
        this.getSitesEnd = false;
        this.currentPage = 0;
      }
      let res = await this.$store
        .dispatch("GET_SITE_PAGENATION", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (addSearch) {
        this.siteLists = this.siteLists.concat(res.sites);
      } else {
        this.siteLists = res.sites;
        this.getSitesEnd = true;
      }
      this.nextExist = res.next_exist;
    },
    authorityCheck(company) {
      // システム管理者と総務部のみ表示
      if (localStorage.user_authority == 1) {
        return true;
      } else if (
        localStorage.user_authority == 4 &&
        company == localStorage.company_id
      ) {
        return true;
      } else {
        return false;
      }
    },
    async updateConstDone(siteId) {
      let data = {
        site_id: siteId
      };
      let res = await this.$store
        .dispatch("UPDATE_CONST_DONE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.getSites(false);
      }
    },
    goMasterSiteDetail(siteId) {
      this.$router.push({ path: `/master_site/${siteId}/detail` });
    },
    selectedCsv(event) {
      if (event) {
        event.preventDefault();
        let files = event.target.files;
        this.file = files[0];
      }
    },
    handleOk(companyId) {
      this.import(companyId);
    },
    async import(companyId) {
      if (this.savingFlag) return;
      this.savingFlag = true;

      this.uploadEnd = false;
      let form = new FormData();
      form.append("file", this.file);
      form.append("company_id", companyId);

      let res = await this.$store
        .dispatch("IMPORT_CSV", { data: form })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      }
      this.sites = res.sites;
      this.uploadEnd = true;
      this.getSites(false);
      this.savingFlag = false;
    }
  }
};
